import React, { Fragment } from "react";
import NavbarLink from "components/App/Navbar/NavbarLink";
import NavbarSection from "components/App/Navbar/NavbarSection";

const WebNavItems = () => (
  <Fragment>
    <NavbarSection>
      <NavbarLink icon="map" href="/flows">
        Flows
      </NavbarLink>
      <NavbarLink icon="check-circle" href="/checklists">
        Checklists
      </NavbarLink>
      <NavbarLink icon="comment-alt" href="/nps">
        NPS
      </NavbarLink>
    </NavbarSection>

    <hr />

    <NavbarSection>
      <NavbarLink icon="palette" href="/themes">
        Themes
      </NavbarLink>
      <NavbarLink icon="users" href="/segments">
        Segments
      </NavbarLink>
      <NavbarLink icon="bullseye" href="/goals">
        Goals
      </NavbarLink>
      <NavbarLink icon="book-open" href="/diagnostics">
        Diagnostics
      </NavbarLink>
    </NavbarSection>
  </Fragment>
);

export default WebNavItems;
